// extracted by mini-css-extract-plugin
module.exports = {"label":"LabeledElement_label__eHjjG","label__text":"LabeledElement_label__text__SbBaO","label__icon":"LabeledElement_label__icon__t4UJB"};